document.addEventListener('click', function(e) {
  var btn = e.target.closest('.collection-atc-btn[data-variant-id]');
  if (!btn) return;

  var variantId = btn.getAttribute('data-variant-id');
  var originalText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) { return res.json(); })
  .then(function(item) {
    var originalUrl = window.location.href;

    // Trick the theme: pretend we're on a product page so it opens the drawer instead of redirecting
    history.pushState({}, '', '/products/' + (item.handle || 'product'));

    // Restore URL once cart finishes loading
    document.addEventListener('theme:cart:loaded', function onLoaded() {
      document.removeEventListener('theme:cart:loaded', onLoaded);
      history.pushState({}, '', originalUrl);
    }, { once: true });

    // Fallback restore in case event never fires
    setTimeout(function() { history.pushState({}, '', originalUrl); }, 3000);

    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

    btn.textContent = 'Added!';
    setTimeout(function() {
      btn.disabled = false;
      btn.textContent = originalText;
    }, 2000);
  })
  .catch(function() {
    btn.disabled = false;
    btn.textContent = originalText;
  });
});
